export default "__VITE_ASSET__DFWsdaMC__"